// extracted by mini-css-extract-plugin
export default {"root":"table-tag_root__p-c2i","label":"table-tag_label__vpHod"};